import React from 'react';

const HomePage = () => (
  <section className="py-20">
    <div className="container">
      <h1 className='scroll-m-20 text-center text-4xl font-extrabold tracking-tight text-balance'>Home page</h1>
    </div>
  </section>
);

export default HomePage;
